import { pick } from 'lodash';
import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';

import { appInfoSelector } from '@common/redux/selectors/app';
import { AppVersion } from 'click-types';

const createStyles = (attributes: any) => {
  const appInfo = useSelector(appInfoSelector);
  const isV4 = appInfo?.version === AppVersion.V4;
  const style = attributes.style || {};

  const width =
    attributes.bannerSize === 'smartBanner' ? '100%' : attributes.width;

  return StyleSheet.create({
    errorView: {
      borderWidth: 0,
    },
    errorText: {
      textAlign: 'center',
      color: '#FF0000',
    },
    borderView: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderWidth: 1,
      borderColor: '#999999',
      borderRadius: 4,
      padding: 8,
      position: 'absolute',
    },
    wrapper: {
      ...pick(attributes, [
        'marginTop',
        'marginLeft',
        'borderRadius',
        'opacity',
        'height',
      ]),
      width,
      display: attributes.hidden ? 'none' : 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      ...(attributes.borderStyle !== 'none'
        ? pick(attributes, ['borderWidth', 'borderColor'])
        : {}),
      borderStyle:
        attributes.borderStyle === 'none' ? 'solid' : attributes.borderStyle,
      zIndex: attributes.zIndex,
      position: 'relative',
      ...(isV4 &&
        pick(style, [
          'top',
          'left',
          'bottom',
          'right',
          'position',
          'transform',
        ])),
    },
    imageMobile: {
      ...pick(attributes, ['height', 'width']),
      position: 'absolute',
    },
  });
};

export default createStyles;
